import WebApi from '@/views/loyalty/shared/modules/web_api'
import { unwrapEnvelope, envelopeError } from '@/views/skud/shared/modules/skud-http'

export class SkudConsumerTokenEndpoint {
  constructor () {
    this.url = `${process.env.VUE_APP_CHARON_URL}api/management/`
    this.webApi = new WebApi()
  }

  // body: {name?, place_ids[], mode, expires_at?} -> {ok:true, data:{token,id,created_at,expires_at}} | {ok:false, error}.
  // data.token — plaintext, возвращается один раз.
  async createToken (placeId, body) {
    const res = await this.webApi.post(this.url + 'places/' + placeId + '/consumer-tokens/', body)
    if (res && !res.status_code && !res.error) return { ok: true, data: res.data }
    return { ok: false, error: envelopeError(res) }
  }

  // -> {tokens} или null.
  async getTokens (placeId) {
    const res = await this.webApi.get(this.url + 'places/' + placeId + '/consumer-tokens/')
    this.lastError = res
    return unwrapEnvelope(res)
  }

  // -> {ok:true} | {ok:false, error}.
  async deleteToken (placeId, id) {
    const res = await this.webApi.delete(this.url + 'places/' + placeId + '/consumer-tokens/' + id)
    // ponytail: WebApi.delete не отдаёт тело конверта — error:true при HTTP 200 не увидим
    if (res === true) return { ok: true }
    return { ok: false, error: envelopeError(res) || 'Ошибка удаления' }
  }
}
